import Toaster from '@bgunnarsson/toaster'

const toaster = {
  instance: null,
  init() {
    this.instance = new Toaster({
      position: 'top right',
      offset: {
        x: 20,
        y: 20,
      },
      customClass: 'tr-toaster',
      duration: 5000,
    })
  },
  success(text, options = {}) {
    this.instance.toast({
      content: this.renderContent(text, 'success'),
      ...options,
    })
  },
  error(text, options = {}) {
    this.instance.toast({
      content: this.renderContent(text, 'error'),
      ...options,
    })
  },
  warning(text, options = {}) {
    this.instance.toast({
      content: this.renderContent(text, 'warning'),
      ...options,
    })
  },
  info(text, options = {}) {
    this.instance.toast({
      content: this.renderContent(text, 'info'),
      ...options,
    })
  },
  renderContent(text, type) {
    return `<div class="tr-toaster__content tr-toaster__content--${type}">${text}</div>`
  },
}

export default toaster
